import React from 'react'
import logo from '../../Icons/softwaredevelopment.jpeg';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Padding from '../Padding';
import NavBar from '../NavBar';
import SEO from '../../components/SEO'
import Sales from '../Sales';

class ControlSystemIntegration extends React.Component {
    render() {
      return (

      <div id='ControlSystemIntegration' style={{backgroundColor: '#0a0a1a'}}>

        <NavBar/>
        <Padding/>
        <Padding/>
        <div className="container-text" style={{padding:"30px"}}>
            <h2>Control System Integration</h2>
            <div> 
              <div style={{padding:"10px"}}> 

<div className="generic-column">
    <h3>Control System Competencies</h3>
    <p>
        We specialise in the full lifecycle development of industrial control, from 
        <strong> Allen-Bradley ControlLogix</strong> and <strong>Siemens SIMATIC S7</strong> logic development 
        to high-performance <strong>Beckhoff TwinCAT</strong> and <strong>CODESYS</strong> environments.
    </p>
    <div className="usp-list">
        <div className="usp-item">
            <strong>Bespoke Software Control:</strong>
            <span>Custom-built C# and C++ control layers for complex logic and algorithmic processing.</span>
        </div>
        <div className="usp-item">
            <strong>Hardware & Platforms:</strong>
            <span>TIA Portal, Studio 5000, TwinCAT 3, and CODESYS-based PLC systems.</span>
        </div>
        <div className="usp-item">
            <strong>Protocol Integration:</strong>
            <span>PROFINET, EtherNet/IP, EtherCAT, Modbus TCP/RTU, and OPC UA.</span>
        </div>
        <div className="usp-item">
            <strong>HMI & SCADA:</strong>
            <span>WinCC, FactoryTalk View, and custom-developed TwinCAT HMI visualisation.</span>
        </div>
    </div>
</div>

              </div>
           </div>
        </div>

        <Padding/>
        <Padding/>

        <Sales/>
        <SEO/>
      </div>
  
      )
    }
  }

export default ControlSystemIntegration;

